var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 11C6.09175 11 3.625 8.53325 3.625 5.5C3.625 2.46675 6.09175 0 9.125 0C12.1582 0 14.625 2.46675 14.625 5.5C14.625 8.53325 12.1582 11 9.125 11ZM13.0392 17.8567C12.2939 18.6019 11.875 19.6121 11.875 20.6663V22H13.2087C14.2629 22 15.2731 21.5811 16.0183 20.8358L22.2581 14.5961C23.0803 13.7738 23.0803 12.4392 22.2581 11.6169C21.4358 10.7947 20.1012 10.7947 19.2789 11.6169L13.0392 17.8567ZM10.0417 20.6663C10.0417 19.1152 10.6457 17.6568 11.7421 16.5605L13.9201 14.3825C12.5671 13.4108 10.9143 12.8324 9.125 12.8324C4.5765 12.8333 0.875 16.5348 0.875 21.0833C0.875 21.5893 1.28567 22 1.79167 22H10.0417V20.6663Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b75c842fb3f57d8b6e3bc43acd249f39.svg";
export { ForwardRef as ReactComponent };